import React, {
  ButtonHTMLAttributes,
  ComponentType,
  FC,
  ReactNode,
} from 'react'

import cn from 'classnames'

import classes from './button.module.scss'

/***
 * Design system: https://www.figma.com/file/JRJ2xtZ27FkTiR6GEvt0yuDd/%E2%9D%96-SMARTY-Design-System?type=design&node-id=9654-45956&t=Omj58skJauXiNxZd-0
 */
export enum Level {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  SecondaryLight = 'secondaryLight',
  Quaternary = 'quaternary',
  Link = 'link',
}

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  level?: Level
  size?: 'regular' | 'tiny'
  as?: ComponentType<{
    children?: ReactNode
    className: string
    [key: string]: unknown
  }>
  dataTestId?: string
}

export const Button: FC<ButtonProps> = ({
  className,
  level = 'primary',
  size = 'regular',
  dataTestId,
  as: Tag = 'button',
  ...props
}) => {
  return (
    <Tag
      className={cn(classes.root, classes[level], classes[size], className)}
      data-testid={dataTestId}
      {...props}
    />
  )
}
